import React, { useEffect, useState, useMemo } from 'react';
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import { DialogPdf } from '../../pures';
import { b64toBlob } from '../../../validators';

const DocumentPDF = (props) => {

    let {
        url,
        permissions,
        fileWasUpload64,
        isExternalUserView,
        externalDocumentsLoaded
    } = props
    const [urlPdf, setUrlPdf] = useState('')
    const [blobAWS, setBlobAWS] = useState("");
    const [fileSelected, setFileSelected] = useState('')
    const [blobUrl, setBlobUrl] = useState("");

    const pdfAWS = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={true} isSSRActive={false} />, [urlPdf])
    const pdf = useMemo(() => {
        const pdfUrl = fileSelected ? `data:application/pdf;base64,${fileSelected}` : '';
        return <PdfViewerAction url={pdfUrl} isExtended={true} isSSRActive={false} />
    }, [fileSelected])

    useEffect(() => {
        if (fileWasUpload64) {
            const blob = b64toBlob(fileWasUpload64, "application/pdf");
            setBlobUrl(blob);
            setFileSelected(fileWasUpload64)
        } else {
            setBlobUrl('')
            setFileSelected('')
        }
    }, [fileWasUpload64]);

    useEffect(() => {
        if (!url) {
            setBlobAWS('')
            setUrlPdf('')
            setBlobUrl('')
            setFileSelected('')
            return
        }
        setBlobAWS(url)
        setUrlPdf(url)
    }, [url, isExternalUserView, externalDocumentsLoaded])

    return (
        <>
            {
                fileWasUpload64 ? (
                    <>
                        <div className='documentPDF-container' id=''>
                            <div id="documentPDF-custom-viewer">
                                {pdf}
                            </div>
                        </div>
                        <div className="documentPDF-pdf-btn">
                            <DialogPdf blobUrl={blobUrl} />
                        </div>
                    </>
                ) : (urlPdf && urlPdf !== '') ? (
                    <>
                        <div className='documentPDF-container'>
                            {pdfAWS}
                        </div>
                        <div className="documentPDF-pdf-btn">
                            <DialogPdf blobUrl={blobAWS} />
                        </div>
                    </>
                ) : ''
            }
        </>
    )
}

export default DocumentPDF